/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IKeyText } from "Interfaces/IKeyText";

/**
 * The award category statuses.
 * @type {IKeyText[]}
 */
export const awardCategoryStatuses: IKeyText[] = [
  {
    key: "Active",
    text: "Active",
  },
  {
    key: "Inactive",
    text: "Inactive",
  },
];

/**
 * The award categories load failure message.
 * @type {string}
 */
export const loadingErrorMessage = "Failed to load award categories";

/**
 * The award category update panel error message.
 * @type {string}
 */
export const updatePanelErrorMessage = "Failed to update award category status";

/**
 * The strings to display impact of changing the award category status to inactive.
 * @type {string[]}
 */
export const inactiveImpactList = [
  "Remove the AC and associated Technology Areas (TA) from the Program Structure FAQ Page.",
  "Hide the TAs from the MVP Application and candidates can no longer apply to these TAs.",
  "Hide the TAs from Event and Activity form dropdowns.",
  "Remove the Distribution Lists (DLs) associated with the inactive AC from the DLs displayed on the website.",
];

/**
 * The strings to display unaffected areas when changing the award category status to inactive.
 * @type {string[]}
 */
export const unaffectedList = [
  "Historical Data and Data Warehouse",
  "ACs/TAs listed on MVP public profiles",
  "ACs/TAs in Admin Center filters and other areas",
  "DLs on the M365 Exchange Admin",
];
